// «Cancelar venta» del detalle de Mis ventas: mismo modal que el Admin VL, contra el endpoint del portal.
// Aparece con `retail.sale.cancel` más el rol Vendedor y en ventas completadas; nace deshabilitado si no cumple.
import { useTranslation } from 'react-i18next';
import { usePermissions } from '@/kit';
import type { SaleSlots } from '@/shared/patterns/SaleReceipt';
import {
    CANCEL_SALE_BUTTON,
    CancelSaleFlow,
    SALE_CANCEL_PERMISSION,
    cancelAvailability,
} from '@/shared/patterns/CancelSale';
import type { RecentSale } from '../../api/usePortal';
import { useCancelPortalSale } from '../api/useCancelPortalSale';
import { usePortalSaleCancellation } from '../api/usePortalSaleCancellation';

interface PortalCancelSaleActionProps {
    sale: RecentSale;
    /** De aquí sale el nombre de los regalos que solo traen su SKU. */
    slots?: SaleSlots;
}

/** Rol Vendedor; el endpoint del portal lo pide junto con `retail.sale.cancel`. */
const WIZARD_OPERATE_PERMISSION = 'retail.wizard.operate';

export function PortalCancelSaleAction(props: PortalCancelSaleActionProps) {
    const { hasPermission } = usePermissions();
    const canCancel =
        hasPermission(SALE_CANCEL_PERMISSION) && hasPermission(WIZARD_OPERATE_PERMISSION);
    if (!canCancel || props.sale.status !== 'COMPLETED') return null;
    return <PortalCancelSale {...props} />;
}

/** Monta la mutación y la lectura aparte para no pedir QueryClient a quien no puede cancelar. */
function PortalCancelSale({ sale, slots }: PortalCancelSaleActionProps) {
    const { t } = useTranslation('ventas');
    const mutation = useCancelPortalSale();
    const { cancellation, status } = usePortalSaleCancellation(sale.saleId);
    const availability = cancelAvailability(cancellation, status, t, 'portal');
    return (
        <CancelSaleFlow
            sale={{
                saleId: sale.saleId,
                folio: sale.saleRef,
                sku: sale.sku,
                lines: sale.lines,
                salePromotionId: sale.salePromotionId,
                salePromotionVersion: sale.salePromotionVersion,
            }}
            mutation={mutation}
            className={CANCEL_SALE_BUTTON}
            slots={slots}
            disabled={!availability.enabled}
            {...(availability.note ? { note: availability.note } : {})}
        />
    );
}
